import React from 'react';
import { PageLayout } from '@voilajsx/uikit/page';
import { Header, Footer, SEO } from '../../../shared/components';

const APP_NAME = import.meta.env.VITE_APP_NAME === 'plotmagic' ? 'PlotMagic' : 'RRD Planners';
const LEGAL_NAME = 'Kuthati Sai Ram';
const EMAIL = 'rrdplotmagic@gmail.com';

const ShippingPage: React.FC = () => {
  return (
    <PageLayout size="full">
      <SEO title={`Shipping & Delivery - ${APP_NAME}`} description="Our shipping and delivery policy" />
      <Header />
      <PageLayout.Content>
        <div className="max-w-4xl mx-auto px-4 py-8">
          <div className="space-y-8">
            <div className="text-center space-y-4">
              <h1 className="text-4xl font-bold text-foreground">Shipping & Delivery Policy</h1>
              <p className="text-muted-foreground">Last updated: April 2026</p>
            </div>

            <div className="prose prose-gray dark:prose-invert max-w-none space-y-8">
              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">1. Digital Delivery</h2>
                <p className="text-muted-foreground leading-relaxed">
                  {APP_NAME} is a fully digital platform. All products (plot map PDFs) are generated and delivered electronically. There are no physical products to ship. Downloads are available instantly after credit deduction.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">2. Credit Delivery</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Credits purchased via our payment gateway are added to your account immediately upon successful payment confirmation. If credits are not reflected within 15 minutes of a successful payment, please contact our support team.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">3. PDF Download Delivery</h2>
                <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                  <li>PDF plot maps are generated in your browser and downloaded instantly</li>
                  <li>No waiting period or processing time required</li>
                  <li>Downloads are available 24/7 from any device with a modern web browser</li>
                  <li>Generated PDFs are A4-sized, print-ready documents</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">4. Service Availability</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Our platform is accessible from anywhere in India and globally via the internet. There are no geographic restrictions on service delivery. All you need is an internet connection and a web browser.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">5. Delivery Issues</h2>
                <p className="text-muted-foreground leading-relaxed">
                  If you experience any issues with credit delivery or PDF downloads, contact us immediately at <a href={`mailto:${EMAIL}`} className="text-primary hover:underline">{EMAIL}</a>. We will resolve delivery issues within 24 hours.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">6. No Physical Shipping</h2>
                <p className="text-muted-foreground leading-relaxed">
                  As a digital-only service, {APP_NAME} does not offer physical shipping, Cash on Delivery (COD), or any physical delivery options. All services and products are delivered digitally through the platform.
                </p>
              </section>
            </div>

            <div className="text-center pt-8 border-t border-border">
              <a href="/" className="inline-flex items-center text-primary hover:underline font-medium">← Back to Home</a>
            </div>
          </div>
        </div>
      </PageLayout.Content>
      <Footer />
    </PageLayout>
  );
};

export default ShippingPage;
